export function normalizePath(url) {
  if (!url) return '';

  let path = url;

  if (typeof window !== 'undefined') {
    const origin = window.location.origin;

    if (path.startsWith(origin)) {
      path = path.slice(origin.length);
    }
  }

  if (!path.startsWith('/')) {
    path = `/${path}`;
  }

  return path;
}

export function findRedirectMatch(redirects, location) {
  if (!redirects?.length) return null;

  const currentPath =
    location.pathname + location.search + location.hash;

  return redirects.find(r => {
    const oldPath = normalizePath(r.oldUrl);
    return oldPath === currentPath;
  });
}